import { Mixin } from 'ts-mixer'
import { HrpMemberClient } from './HrpMemberClient'
import { HrpClaimsClient } from './HrpClaimsClient'
import { HrpAccumulatorClient } from './HrpAccumulatorClient'
import { HrpCorrespondenceClient } from './HrpCorrespondenceClient'
import { HrpDepartmentClient } from './HrpDepartmentClient'
import { HrpBenefitPlanClient } from './HrpBenefitPlanClient'
import { HrpEnrollmentClient } from './HrpEnrollmentClient'
import { HrpBillClient } from './HrpBillClient'
import { HrpAuthorizationClient } from './HrpAuthorizationClient'
import { HrpAccountClient } from './HrpAccountClient'

export class HrpClient extends Mixin(
    HrpMemberClient, 
    HrpClaimsClient,
    HrpAccumulatorClient,
    HrpCorrespondenceClient,
    HrpDepartmentClient,
    HrpBenefitPlanClient,
    HrpEnrollmentClient,
    HrpBillClient,
    HrpAuthorizationClient,
    HrpAccountClient,
) {
    constructor(
        hrpProxyApiUrl = process.env.HRP_PROXY_API_URL, 
        hrpProxySecretName = process.env.HRP_PROXY_SECRET_NAME, 
        axiosOptions
    ) {
        super(hrpProxyApiUrl, hrpProxySecretName, axiosOptions)
    }
}
